import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const creatingCampaign = {
  popover: {
    title: 'Creating a New Campaign',
    description:
      "Email ad campaigns add eye-catching banners right below employee signatures—effortlessly landing in your audience's inbox. This quick tour shows you how to create them."
  }
};
